module.exports = __webpack_public_path__ + "img/Capture2.8c06c7db.jpg";